import styles from './PartnerContactConfirmation.module.scss';

import mailWings from 'images/icons/mail-wings.svg';

import { Image } from 'components/Image/Image';
import { ModalHeader } from 'components/Modal/Header/ModalHeader';
import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { PARTNER_CONTACT_CONFIRMATION_TEST_ID } from './PartnerContactConfirmation.const';

interface IPartnerContactConfirmationProps {
  partner: string;
  onRequestClose: () => void;
}

const PartnerContactConfirmation: React.FunctionComponent<
  IPartnerContactConfirmationProps & WithTranslation
> = ({ partner, t, onRequestClose }) => (
  <>
    <ModalHeader className={styles.modalHeader} onCloseButtonClick={onRequestClose} />
    <section
      className={styles.confirmWrapper}
      data-testid={PARTNER_CONTACT_CONFIRMATION_TEST_ID.partnerContactConfirmation}
    >
      <section className={styles.confirmation}>
        <Image className={styles.confirmImage} src={mailWings} />
        <section className={styles.confirmText}>
          <h2 className={styles.confirmTitle}>{t('partner-message-sent')}</h2>
          <p>{t('partner-contact-thanks', { partner })}</p>
          <p>{t('partner-contact-next-step')}</p>
        </section>
      </section>
    </section>
  </>
);

const TranslatedComponent = withTranslation()(PartnerContactConfirmation);

export { TranslatedComponent as PartnerContactConfirmation };
